export class BaseClass {
  id!: string;
  /** "creation_date" */
  createdAt!: string;
  /** "last_modifier_date" */
  modifiedAt!: string;
  /** "created_by" */
  createdBy!: string;
  /** "last_modifier" */
  modifiedBy!: string;
  /** "created_tick" */
  createdTick?: number;
  /** "last_modifier_tick" */
  modifiedTick?: number;
}
